<div class="text-center">
	<h4>Are you sure you would like to delete this policy?</h4>
	<p class="mt-2">This is a permanent action and can't be undone</p>
</div>
<div class="mt-8 flex items-center justify-between">
	<app-button btn="secondary" (click)="close()" size="small"
		>Go back</app-button
	>
	<app-button (click)="deletePolicy()" size="small">Delete policy</app-button>
</div>
